$(document).ready(function () {
  var maxDotss = 5; // Only show 3 dots at a time
  var $slickElements = $('.shop-by-player-block');

  // Custom dot visibility logic
  function updateVisibleDots(slick) {
    if (!slick.$dots) return;

    var $dots = slick.$dots.find('li');
    var totalDots = $dots.length;
    var activeIndex = $dots.filter('.slick-active').index();

    var start = Math.max(0, activeIndex - Math.floor(maxDotss / 2));
    var end = Math.min(totalDots, start + maxDotss);

    if (end - start < maxDotss) {
      start = Math.max(0, end - maxDotss);
    }

    $dots.hide();
    $dots.slice(start, end).show();
  }

  // Event to update pagination info + limit visible dots
 $slickElements.on('init reInit afterChange', function (event, slick, currentSlide) {
    if (!slick || typeof slick.slideCount === 'undefined') return;

    let totalDots = slick.$slider.find(".slick-dots li").length;
    let activeDotIndex = slick.$slider.find(".slick-dots li.slick-active").index();

    let $status = slick.$slider.closest(".shop-by-player").find(".pagingInfo");

    if ($status.length > 0) {
        if (slick.slideCount >= 5) {
            // Show paging info only when there are 5 or more slides
            $status.text(`${activeDotIndex + 1} / ${totalDots}`).show();
        } else {
            // Hide paging info if slides are less than 5
            $status.hide();
        }
    }

    updateVisibleDots(slick); // Hide/show dots
});


  // Initialize Slick
  $slickElements.slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 4.2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
